import { render, staticRenderFns } from "./ChangeTime.vue?vue&type=template&id=82809518&scoped=true&"
import script from "./ChangeTime.vue?vue&type=script&lang=js&"
export * from "./ChangeTime.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTime.vue?vue&type=style&index=0&id=82809518&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82809518",
  null
  
)

export default component.exports